export default __webpack_public_path__ + "2845756f537094e39dac84222747f83d.ttf";